import { createContext } from 'react'

export const CompanyBillingContext = createContext<{
  remainingCredits: number
  hasCompany: boolean
  hasValidBankcard: boolean
  hasPaymentMethod: boolean
  hasBillingDetails: boolean
  isInsolvent: boolean
}>({
  remainingCredits: 0,
  hasCompany: false,
  hasValidBankcard: false,
  hasPaymentMethod: false,
  hasBillingDetails: false,
  isInsolvent: true,
})
